import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error_white",
  "use": "icon-error_white-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"#FFFFFF\" id=\"icon-error_white\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\" /><circle cx=\"12\" cy=\"19\" r=\"2\" /><path d=\"M10 3h4v12h-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol